module.exports = __webpack_public_path__ + "assets/img/team/alokeparna-ray.jpg";